// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"926f0775","455":"8e1d282e","977":"d35724d6"}[chunkId] + ".chunk.js";
};